export const ACCOUNT_PROVISIONING_STATUS = Object.freeze({
  PENDING: 'pending',
  COMPLETED: 'completed'
})
